// The four voices, as data rather than code, so the parameter panel can edit
// them and a URL hash can carry a whole sound world.
//
// Each preset is a two-operator FM voice: a carrier at `frequency`, modulated
// by an oscillator at `frequency * harmonicity`, with `modulationIndex`
// setting how hard. The amplitude envelope is percussive by default.

export const SOUNDS = ['kick', 'snare', 'hat', 'tone']

export const PRESETS = {
  kick: {
    label: 'kick',
    frequency: 55,
    harmonicity: 0.5,
    modulationIndex: 8,
    attack: 0.001,
    decay: 0.28,
    sustain: 0,
    release: 0.05,
    // a short downward sweep is most of what makes a kick read as a kick
    pitchDecay: 0.06,
    gain: 0.9,
  },
  snare: {
    label: 'snare',
    frequency: 220,
    harmonicity: 3.7,      // inharmonic ratio -> noisy
    modulationIndex: 28,
    attack: 0.001,
    decay: 0.16,
    sustain: 0,
    release: 0.05,
    pitchDecay: 0.01,
    gain: 0.6,
  },
  hat: {
    label: 'hat',
    frequency: 880,
    harmonicity: 5.3,
    modulationIndex: 34,
    attack: 0.001,
    decay: 0.05,
    sustain: 0,
    release: 0.02,
    pitchDecay: 0.005,
    gain: 0.35,
  },
  tone: {
    label: 'tone',
    frequency: 330,
    harmonicity: 2,
    modulationIndex: 6,
    attack: 0.005,
    decay: 0.2,
    sustain: 0.4,
    release: 0.6,
    pitchDecay: 0.01,
    gain: 0.5,
  },
}

// Which preset fields the parameter panel exposes, and over what range.
export const PARAM_RANGES = {
  frequency: { min: 30, max: 1200, step: 1 },
  harmonicity: { min: 0.25, max: 8, step: 0.05 },
  modulationIndex: { min: 0, max: 50, step: 0.5 },
  attack: { min: 0.001, max: 0.2, step: 0.001 },
  decay: { min: 0.01, max: 1.5, step: 0.01 },
  sustain: { min: 0, max: 1, step: 0.01 },
  release: { min: 0.01, max: 2, step: 0.01 },
  pitchDecay: { min: 0, max: 0.4, step: 0.005 },
  gain: { min: 0, max: 1, step: 0.01 },
}

export const EDITABLE_PARAMS = Object.keys(PARAM_RANGES)

export function clonePresets() {
  return structuredClone(PRESETS)
}
